import { InputProps, useInput } from "react-admin";
import { useField } from "react-final-form";
import { DriverPicker } from "./DriverPicker";

interface Props extends InputProps {}

export const RaDriverPicker = (props: Props) => {
  const {
    input: { onChange },
  } = useField(props.source);

  const {
    id,
    input,
    isRequired,
    meta: { error, submitError, touched },
  } = useInput({
    onChange,
    type: "text",
    ...props,
  });

  return (
    <DriverPicker
      {...props}
      {...input}
      name={props.source}
      onChange={onChange}
      touched={touched}
      error={error}
      id={id}
      required={isRequired}
      submitError={submitError}
    />
  );
};
